import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

export default PhoneInput;
